import { GetterTree } from 'vuex';
import { State } from './overview.store';

const getters: GetterTree<State, State> = {
  getCurrentChannel: state => {
    return state.currentChannel;
  },
  getChannels: state => {
    return state.channels;
  },
  getTotalChannels: state => {
    return state.totalChannels;
  },
  getSearchTotalChannels: state => {
    return state.searchTotalChannels;
  },
  getShowAddChannel: state => {
    return state.showAddChannel;
  },
  getShowDeleteChannel: state => {
    return state.showDeleteChannel;
  },
  getRefreshChannels: state => {
    return state.refreshChannels;
  },
  getAlertRuleChannels: state => {
    return state.alertRuleChannels;
  },
  getAlertGroupRuleChannels: state => {
    return state.alertGroupRuleChannels;
  },
  getTotalAlertRuleChannels: state => {
    return state.totalAlertRuleChannels;
  },
};
export default getters;
